import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';
import useBeautyFilterBanubaStore from 'stores/beautyFilter/beautyFilterBanubaStore';
import useBeautiStore from 'stores/beautyFilter/beautiStore';
import { useCallback, useEffect, useRef } from 'react';
import { MOOD_TABLE } from 'constants/beautyFilterTables';

const useApplyBeautyFilter = () => {
  const store = useBeautyFilterStore();
  const { inited, setIsLoading } = store;
  const { selectedKey: selectedMoodKey } = store.mood;
  const { selectedKey: selectedStickerKey } = store.sticker;
  const banubaStore = useBeautyFilterBanubaStore();
  const { state, presetValue, applyBanuba } = banubaStore;
  const { setBeautiMode } = useBeautiStore();
  const reqId = useRef(0);

  // Apply Mood
  const applyMood = useCallback(
    (key: string) => {
      if (key === 'be_default') {
        Device.setVideoEffect(0, 'se_be_default', null);
        setBeautiMode(0);
      } else {
        Device.setBeautiMode(0, 0);
        Device.setVideoEffect(0, key, MOOD_TABLE[key].settings);
      }
    },
    [setBeautiMode]
  );

  useEffect(() => {
    if (inited) applyMood(selectedMoodKey);
  }, [selectedMoodKey, applyMood, inited]);

  // Apply Sticker
  const applySticker = useCallback(
    async (stickerKey: string | null) => {
      reqId.current += 1;
      const _reqId = reqId.current;

      if (!stickerKey) {
        Device.setSticker(0, null);
        return;
      }

      const isDownloaded = await new Promise<boolean>((resolve) => {
        Device.isStickerDownloaded(stickerKey, (_id: string, result: boolean) => {
          if (_reqId !== reqId.current) return;
          resolve(result);
        });
      });
      if (isDownloaded) {
        Device.setSticker(0, stickerKey);
        return;
      }

      setIsLoading(true);
      try {
        await new Promise<void>((resolve, reject) => {
          Device.downloadStickerResource(stickerKey, (_id: string, progress: number) => {
            if (_reqId !== reqId.current) return;
            if (progress === -1) {
              reject(new Error('Download failed'));
            } else if (progress === 100) {
              resolve();
            }
          });
        });
        Device.setSticker(0, stickerKey);
      } catch (error) {
        BLog.error('Sticker download failed:', error);
      } finally {
        reqId.current += 1;
        setIsLoading(false);
      }
    },
    [setIsLoading]
  );

  useEffect(() => {
    if (inited) applySticker(selectedStickerKey);
  }, [selectedStickerKey, applySticker, inited]);

  // Apply Banuba
  useEffect(() => {
    if (inited) applyBanuba();
  }, [state, presetValue, applyBanuba, inited]);
};

export default useApplyBeautyFilter;
